import React from 'react';

import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import AiSparkleIcon from '@atlaskit/icon/core/ai-sparkle';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';

import {
	ALL_AGENTS_CATEGORY_ID,
	FAVOURITE_AGENTS_CATEGORY_ID,
	RECOMMENDED_CATEGORY_ID,
	VERIFIED_AGENTS_CATEGORY_ID,
	YOUR_AGENTS_CATEGORY_ID,
} from './categoryIds';
// eslint-disable-next-line import/extensions
import { defaultAgentResultsEntryPoint } from './entrypoints/default/defaultAgentResults.entrypoint';
import { messages as recommendedMessages } from './entrypoints/recommended/messages';
// eslint-disable-next-line import/extensions
import { recommendedAgentResultsEntryPoint } from './entrypoints/recommended/recommendedAgentResults.entrypoint';
import { messages } from './messages';
import type { BrowseAgentCategory, CategoryEntryPoint, SkeletonProps } from './types';
import { RecommendedSkeleton } from './components/RecommendedSkeleton';
import { createCardListSkeleton } from './utils/createCardListSkeleton';

export const DEFAULT_CATEGORIES: readonly BrowseAgentCategory[] = [
	{
		id: RECOMMENDED_CATEGORY_ID,
		name: recommendedMessages.recommendedAgentsCategory,
		entrypoint: recommendedAgentResultsEntryPoint as CategoryEntryPoint,
		icon: AiSparkleIcon,
		skeleton: ({ testId }: SkeletonProps): React.JSX.Element => (
			<RecommendedSkeleton testId={testId} />
		),
	},
	{
		id: ALL_AGENTS_CATEGORY_ID,
		name: messages.allAgentsCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: AiAgentIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: FAVOURITE_AGENTS_CATEGORY_ID,
		name: messages.favouritesCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: StarStarredIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: YOUR_AGENTS_CATEGORY_ID,
		name: messages.yourAgentsCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: PersonAvatarIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: VERIFIED_AGENTS_CATEGORY_ID,
		name: messages.verifiedCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: CheckCircleIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
];
